module.exports = __webpack_public_path__ + "img/ballot-check.9194de35.svg";